<template>
    <DeleteModal
        :visible.sync="showModal"
        :is-loading="isLoading"
        :is-submiting="isSubmiting"
        :disabled="!id"
        description="Deseja realmente excluir este popup? Esta ação não poderá ser desfeita."
        @cancel="toggleModal"
        @confirm="onSubmit"
        @closed="resetModal"
    >
        <div v-if="popup" class="d-flex align-items-center">
            <i class="el-icon-picture-outline"></i>
            <span class="font-weight-bold ml-2">{{ popup.title }}</span>
        </div>
    </DeleteModal>
</template>
<script>
    // Components
    import { Notification } from "element-ui";

    import DeleteModal from "@/components/_micro/modals/DeleteModal.vue";

    // Api
    import { PopupApi } from "@/api/PopupApi";

    const popupApi = new PopupApi();

    export default {
        data() {
            return {
                id: null,
                popup: null,
                showModal: false,
                isLoading: false,
                isSubmiting: false,
            }
        },
        methods: {
            async show() {
                try {
                    this.isLoading = true;

                    const res = await popupApi.show(this.id);

                    this.popup = res?.data ?? res;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o popup! Algo inesperado ocorreu.'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async onSubmit() {
                if (!this.id) return;

                this.isSubmiting = true;

                try {
                    await popupApi.destroy(this.id);

                    Notification.success({
                        title: 'Sucesso',
                        message: 'Popup excluído com sucesso!'
                    });

                    this.$emit('deleted');
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível excluir o popup!'
                    });
                } finally {
                    this.isSubmiting = false;
                    this.toggleModal();
                }
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetModal() {
                this.id = null;
                this.popup = null;
            },
        },
        components: {
            DeleteModal,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/popup/PopupDeleteModal.vue